import { Link } from 'react-router-dom';

export default function AboutHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[520px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20warm%20illustration%20of%20a%20creative%20studio%20workspace%20with%20drawing%20tablets%20and%20comic%20art%20on%20walls%2C%20warm%20golden%20evening%20lighting%2C%20cozy%20atmosphere%2C%20digital%20painting%20style%2C%20artistic%20vibe%2C%20clean%20composition&width=1920&height=800&seq=about-hero-manga&orientation=landscape"
          alt="虫虫漫画网 - 关于我们"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        <span className="inline-flex items-center gap-2 px-3 py-1 text-xs font-medium text-accent-800 bg-accent-100/20 backdrop-blur-sm rounded-full mb-5 font-label border border-accent-300/20">
          <span className="w-1 h-1 rounded-full bg-accent-400"></span>
          关于虫虫漫画网
        </span>
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-background-50 mb-4">
          让每个人都能
          <br />
          自由阅读漫画
        </h1>
        <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto leading-relaxed">
          虫虫漫画网成立于2020年，专注于为中文读者提供最优质的韩国漫画阅读体验。
          下拉式完整版免费阅读是我们的核心理念。
        </p>
      </div>

      {/* Breadcrumb */}
      <div className="absolute bottom-6 left-0 right-0 z-10">
        <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
          <nav className="flex items-center gap-2 text-xs text-background-50/60" aria-label="面包屑导航">
            <Link to="/" className="hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer">
              首页
            </Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-background-50/90">关于我们</span>
          </nav>
        </div>
      </div>
    </section>
  );
}

export function BrandStory() {
  return (
    <section className="w-full py-16 md:py-24 bg-gradient-to-b from-secondary-100 via-secondary-50/50 to-background-50">
      <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
        <div className="mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-4 font-label">
            <span className="w-1 h-1 rounded-full bg-primary-500"></span>
            品牌故事
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-3">
            虫虫漫画的品牌之路
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
            虫虫漫画网成立于2020年，由一群热爱韩国漫画的年轻团队创立。我们深知漫友们对于完整版、无删减内容的渴望，也理解传统翻页式阅读的不便。因此，我们决定打造一个专注于下拉式阅读体验的漫画平台，让每一位读者都能以最自然的方式享受漫画的乐趣。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl mt-4">
            从最初的几十部漫画到如今2000+的资源库，从几百个用户到500万+的忠实读者，虫虫漫画始终坚持以"下拉式完整版免费阅读"为核心理念。我们不删减任何内容，不设置付费墙，让好漫画触手可及。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20creative%20team%20collaborating%20on%20digital%20comics%2C%20modern%20office%20setting%2C%20warm%20natural%20lighting%2C%20friendly%20atmosphere%2C%20digital%20art%20style%2C%20clean%20composition%2C%20professional%20vibe&width=700&height=500&seq=about-team-01&orientation=landscape"
              alt="虫虫漫画团队"
              title="虫虫漫画网 - 专业漫画运营团队"
              className="w-full rounded-xl object-cover"
            />
          </div>
          <div>
            <div className="text-6xl md:text-7xl lg:text-8xl font-bold font-heading text-foreground-950 mb-3">
              500万<span className="text-xl text-foreground-400 font-normal">+</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6">
              累计服务的忠实读者数量，这个数字每天都在增长。我们的读者遍布全国各地，从学生到上班族，从漫画新手到资深漫友。
            </p>
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-background-50 rounded-xl p-4">
                <div className="text-2xl font-bold font-heading text-primary-500">2000+</div>
                <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
              </div>
              <div className="bg-background-50 rounded-xl p-4">
                <div className="text-2xl font-bold font-heading text-primary-500">300+</div>
                <div className="text-xs text-foreground-500 mt-1">月更新量</div>
              </div>
              <div className="bg-background-50 rounded-xl p-4">
                <div className="text-2xl font-bold font-heading text-primary-500">30万+</div>
                <div className="text-xs text-foreground-500 mt-1">日活跃</div>
              </div>
              <div className="bg-background-50 rounded-xl p-4">
                <div className="text-2xl font-bold font-heading text-primary-500">99.7%</div>
                <div className="text-xs text-foreground-500 mt-1">好评率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function Features() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 mb-14">
          <div className="lg:flex-1">
            <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-4 font-label">
              平台优势
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 leading-tight">
              为什么选择
              <br />
              虫虫漫画
            </h2>
          </div>
          <div className="lg:flex-1 lg:pt-2">
            <p className="text-sm text-foreground-500 leading-relaxed max-w-md">
              我们始终将用户体验放在第一位。从下拉式阅读到完整版内容，从加载速度到界面设计，每一个细节都经过精心打磨。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          <div className="bg-background-100 rounded-xl p-6 md:p-7">
            <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5">
              <i className="ri-book-read-line text-xl text-primary-600"></i>
            </div>
            <h3 className="text-lg font-bold font-heading text-foreground-900 mb-2.5">下拉式阅读</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              原生韩国漫画下拉式排版，手指轻滑即可流畅阅读，告别翻页，沉浸式体验。
            </p>
          </div>
          <div className="bg-background-100 rounded-xl p-6 md:p-7">
            <h3 className="text-lg font-bold font-heading text-foreground-900 mb-4 text-center">完整无删减</h3>
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20representing%20complete%20uncensored%20content%2C%20a%20locked%20book%20opening%20with%20glowing%20light%2C%20warm%20dramatic%20lighting%2C%20digital%20art%2C%20clean%20composition%2C%20symbolic%20imagery&width=400&height=250&seq=about-feat-01&orientation=landscape"
              alt="完整无删减内容"
              className="w-full rounded-lg object-cover mt-4"
            />
          </div>
          <div className="bg-background-100 rounded-xl p-6 md:p-7">
            <h3 className="text-lg font-bold font-heading text-foreground-900 mb-4 text-center">完全免费</h3>
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20free%20access%20concept%2C%20open%20gate%20with%20warm%20light%20streaming%20through%2C%20welcoming%20atmosphere%2C%20digital%20art%2C%20clean%20composition%2C%20inviting%20vibe&width=400&height=250&seq=about-feat-02&orientation=landscape"
              alt="完全免费阅读"
              className="w-full rounded-lg object-cover mt-4"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export function Testimonials() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-4 font-label">
            <span className="w-1.5 h-1.5 rounded-full bg-secondary-500"></span>
            用户口碑
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950">
            媒体与用户评价
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          <div className="bg-background-50 rounded-xl p-6 md:p-7">
            <i className="ri-double-quotes-l text-3xl text-foreground-200"></i>
            <p className="text-sm text-foreground-600 leading-relaxed mt-3 mb-4">
              虫虫漫画网的出现，填补了中文市场韩国漫画完整版免费阅读的空白。下拉式的阅读体验完全还原了韩漫的原生感，值得推荐。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-primary-200 flex items-center justify-center">
                <span className="text-xs font-bold text-primary-700">漫</span>
              </div>
              <div>
                <div className="text-xs font-semibold text-foreground-900">漫画之家</div>
                <div className="text-xs text-foreground-400">知名漫画媒体</div>
              </div>
            </div>
          </div>
          <div className="bg-background-50 rounded-xl p-6 md:p-7">
            <i className="ri-double-quotes-l text-3xl text-foreground-200"></i>
            <p className="text-sm text-foreground-600 leading-relaxed mt-3 mb-4">
              作为漫画行业的观察者，我认为虫虫漫画的免费模式将推动更多人接触韩国漫画文化，下拉式阅读确实是未来的趋势。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-accent-200 flex items-center justify-center">
                <span className="text-xs font-bold text-accent-700">文</span>
              </div>
              <div>
                <div className="text-xs font-semibold text-foreground-900">文创观察</div>
                <div className="text-xs text-foreground-400">行业评论媒体</div>
              </div>
            </div>
          </div>
          <div className="relative rounded-xl overflow-hidden h-56 lg:h-auto">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20portrait%20of%20a%20happy%20reader%20holding%20smartphone%20displaying%20colorful%20manga%20page%2C%20warm%20indoor%20cozy%20setting%2C%20soft%20lighting%2C%20digital%20art%2C%20clean%20composition%2C%20joyful%20expression&width=600&height=800&seq=about-review-img&orientation=portrait"
              alt="虫虫漫画网读者评价"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-4">
              <div className="text-sm font-semibold text-background-50">漫画爱好者小雨</div>
              <div className="text-xs text-background-50/70">忠实读者 · 2年</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const faqData = [
  {
    question: '虫虫漫画网的内容是否完全免费？',
    answer:
      '是的，虫虫漫画网所有漫画资源均免费开放阅读。我们不设置任何付费墙，也不限制阅读次数。读者可以随时随地免费享受下拉式完整版韩国漫画。',
  },
  {
    question: '什么是下拉式阅读？',
    answer:
      '下拉式阅读（Webtoon/条漫）是源自韩国的原生漫画阅读方式。漫画以长条形式连续排版，读者只需向下滑动即可流畅阅读，无需翻页。这种方式更符合手机阅读习惯，沉浸感更强。',
  },
  {
    question: '虫虫漫画网的内容是否完整无删减？',
    answer:
      '是的，我们承诺所有漫画均为完整版无删减。我们与多家韩国漫画版权方合作，确保中文读者能够原汁原味地阅读每一部作品，不错过任何精彩内容。',
  },
  {
    question: '网站支持哪些设备访问？',
    answer:
      '虫虫漫画网完美适配手机、平板和电脑端。其中手机端体验最佳，下拉式阅读在触摸屏上表现尤为出色。PC端同样支持鼠标滚轮流畅阅读。',
  },
  {
    question: '如何联系商务合作或版权合作？',
    answer:
      '欢迎发送邮件至 contact@chongchongmanhua.com，请在邮件中注明合作类型（商务合作/版权合作/媒体合作）及相关信息，我们的团队会在3个工作日内回复。',
  },
];

export function FAQ() {
  return (
    <section id="faq" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-6 md:px-10 max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-4 font-label">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950">
            FAQ 常见问题解答
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            关于虫虫漫画网最常见的问题，如果你有其他疑问欢迎通过邮件联系我们。
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              itemScope
              itemType="https://schema.org/Question"
              className="bg-background-100 rounded-xl border border-background-200/70 p-5 md:p-6"
            >
              <h3 itemProp="name" className="text-base font-bold font-heading text-foreground-900 mb-3">
                {item.question}
              </h3>
              <div
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <p itemProp="text" className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ContactCTA() {
  return (
    <section className="relative w-full py-24 md:py-32 flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20warm%20atmospheric%20illustration%2C%20sunset%20city%20skyline%20view%20from%20cozy%20window%2C%20warm%20golden%20and%20coral%20tones%2C%20dreamy%20vibe%2C%20digital%20painting%2C%20clean%20composition%2C%20hopeful%20atmosphere&width=1920&height=800&seq=about-cta-manga&orientation=landscape"
          alt="加入虫虫漫画"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/65 via-foreground-950/45 to-foreground-950/65"></div>
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-background-50 mb-5">
          联系我们
        </h2>
        <p className="text-sm md:text-base text-background-50/75 mb-10 leading-relaxed max-w-xl mx-auto">
          商务合作、版权合作、媒体垂询
          <br />
          欢迎随时联系我们
        </p>
        <a
          href="mailto:contact@chongchongmanhua.com"
          className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-foreground-800 transition-colors duration-300 whitespace-nowrap group cursor-pointer"
        >
          <span className="w-6 h-6 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-mail-line text-background-50 text-xs"></i>
          </span>
          contact@chongchongmanhua.com
          <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
        </a>
      </div>
    </section>
  );
}